module.exports = __webpack_public_path__ + "img/fondo.b9324197.jpg";